import { render, staticRenderFns } from "./manageNpt.vue?vue&type=template&id=1a19abf2"
import script from "./manageNpt.vue?vue&type=script&lang=ts"
export * from "./manageNpt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports